import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

// Pipes
import { CustomDatePipe } from '@pipes/date.pipe';
import { PricePipe } from '@pipes/price.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { CustomPopupComponent } from './components/custom-popup/custom-popup.component';
import { HeaderComponent } from '@components/header/header.component';
import { FooterComponent } from '@components/footer/footer.component';
import { ChatbotComponent } from './components/chatbot/chatbot.component';
import { AddOnListComponent } from './components/add-on-list/add-on-list.component';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    FontAwesomeModule
  ],
  exports: [
    CommonModule,
    CustomDatePipe,
    FormsModule,
    PricePipe,
    ReactiveFormsModule,
    RouterModule,
    FontAwesomeModule,
    ConfirmDialogComponent,
    CustomPopupComponent,
    FooterComponent,
    HeaderComponent,
    ChatbotComponent,
    AddOnListComponent
  ],
  declarations: [
    CustomDatePipe,
    PricePipe,
    ConfirmDialogComponent,
    CustomPopupComponent,
    FooterComponent,
    HeaderComponent,
    ChatbotComponent,
    AddOnListComponent
  ]
})
export class SharedModule {
}
